import Eshops from './Eshops';

export default Eshops;



// WEBPACK FOOTER //
// ./src/components/Query/Eshops/index.ts